import React, { useState, useEffect } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

const EditMessageModal = ({ open, onClose, message }) => {
    const [text, setText] = useState("");

    useEffect(() => {
        if (open && message) {
            setText(message.body);
        }
    }, [open, message]);

    const handleClose = () => {
        setText("");
        onClose();
    };

    const handleEdit = async () => {
        try {
            await api.put(`/messages/${message.id}`, {
                body: text,
            });
            toast.success(i18n.t("messageOptionsMenu.success"));
            handleClose();
        } catch (err) {
            toastError(err);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{i18n.t("messageOptionsMenu.edit")}</DialogTitle>
            <DialogContent>
                <TextField
                    multiline
                    minRows={3}
                    fullWidth
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    variant="outlined"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    {i18n.t("confirmationModal.buttons.cancel")}
                </Button>
                <Button onClick={handleEdit} color="primary">
                    {i18n.t("confirmationModal.buttons.confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditMessageModal;
